import classNames from "classnames";

import { TriangleIcon } from "../../../../icons";
import { CategoryIcon } from "../../../transactions/CategoryIcon";
import { CategoryFlattenedItem } from "../utils";
import styles from "../Categories.module.scss";

export const CategoryIdCell: React.FC<{
    isCollapsed?: boolean;
    item: CategoryFlattenedItem;
    isCollapsible?: boolean;
}> = ({ item, isCollapsed, isCollapsible }) => (
    <div
        className={classNames(
            "d-flex align-items-center",
            styles.categoryIdCell,
            styles.categoryIdCellSubCategory,
        )}
    >
        <div>
            {item.parentId ? (
                <div className={classNames(styles.rowIcon, styles.childIcon)} />
            ) : (
                <CategoryIcon categoryId={item.id as string} />
            )}
        </div>

        <div>
            <span className={styles.addCategoryInput}>{item.meta.label}</span>

            {isCollapsible && (
                <span
                    className={classNames(
                        styles.triangleIcon,
                        isCollapsed && styles.triangleIconCollapsed,
                    )}
                >
                    <TriangleIcon />
                </span>
            )}
        </div>
    </div>
);
